import type { RouterConfig } from '@nuxt/schema';

export default {
	scrollBehavior(to, _from, savedPosition) {
		let insidePagesPosition;

		return new Promise(resolve => {
			if (insidePagesPosition) {
				resolve({ top: insidePagesPosition });
			} else if (savedPosition) {
				resolve(savedPosition);
			} else if (to.hash) {
				resolve({
					el: to.hash
				});
			} else {
				resolve({ top: 0 });
			}
		});
	}
} as RouterConfig;
